import { ExchangeRates } from '../../types/exchangeRates';

type ExchangeRatesState = ExchangeRates | null;
interface ExchangeRatesAction {
  type: string;
  exchangeRates: ExchangeRates;
}

export default (
  state: ExchangeRatesState = null,
  action: ExchangeRatesAction
): ExchangeRatesState => {
  switch (action.type) {
    case 'EXCHANGE_RATES':
      return action.exchangeRates;
    default:
      return state;
  }
};
